// Injects an elegant, non-intrusive "Área do Cliente" / "Login" trigger into the client's public website HTML

export function injectClientLoginButton(rawHtml: string, slug: string, clientName?: string, primaryColor = '#18181b'): string {
  if (!rawHtml) return '';

  const loginUrl = `#/login/${slug}`;

  // Floating discreet badge or header action
  const injectedCode = `
    <!-- NYROH WHITE-LABEL LOGIN INJECTION -->
    <style>
      .client-access-trigger {
        position: fixed;
        bottom: 24px;
        left: 24px;
        z-index: 99999;
        display: inline-flex;
        align-items: center;
        gap: 8px;
        background: rgba(15, 23, 42, 0.92);
        backdrop-filter: blur(8px);
        color: #ffffff !important;
        font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
        font-size: 12px;
        font-weight: 600;
        padding: 8px 14px;
        border-radius: 9999px;
        text-decoration: none !important;
        box-shadow: 0 4px 14px rgba(0, 0, 0, 0.2);
        border: 1px solid rgba(255, 255, 255, 0.15);
        transition: all 0.2s ease-in-out;
        cursor: pointer;
        opacity: 0.85;
      }
      .client-access-trigger:hover {
        opacity: 1;
        transform: translateY(-2px);
        background: ${primaryColor};
        color: #ffffff !important;
        box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
      }
      .client-access-trigger svg {
        width: 14px;
        height: 14px;
      }
      @media (max-width: 640px) {
        .client-access-trigger {
          bottom: 16px;
          left: 16px;
          padding: 6px 12px;
          font-size: 11px;
        }
      }
    </style>
    <a href="${loginUrl}" onclick="event.preventDefault(); event.stopPropagation(); try { if (window.top) { window.top.location.hash = '${loginUrl}'; } } catch(e) {} try { if (window.parent) { window.parent.postMessage({ type: 'NAVIGATE', hash: '${loginUrl}' }, '*'); window.parent.location.hash = '${loginUrl}'; } } catch(e) {} window.location.hash = '${loginUrl}'; return false;" class="client-access-trigger" title="Acesso à Área de Gestão">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <rect width="18" height="11" x="3" y="11" rx="2" ry="2"/>
        <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
      </svg>
      <span>Área Restrita</span>
    </a>
  `;

  if (rawHtml.includes('</body>')) {
    return rawHtml.replace('</body>', `${injectedCode}</body>`);
  }
  return rawHtml + injectedCode;
}
